<template>
  <SfModal v-if="modalOpen" size="xs" :hide-close="true" @close="close">
    <template #title>
      <div class="sf-alignc sf-font-normal">
        <span v-dompurify-html="modalTitle" />
      </div>
    </template>
    <template #body>
      <div class="sf-level sf-below-2">
        <SfCheckbox
          v-if="eligible"
          v-model="reportRemoval"
          :label="I18n.t('report_template_editor.remove_locked_reports')"
        ></SfCheckbox>
      </div>
    </template>

    <template #footer>
      <SfButtonDs variant="danger" @click="apply">{{
        I18n.t('js.global_confirmation_modal.combined.remove_button')
      }}</SfButtonDs>
      <SfButtonDs variant="secondary" @click="close">{{
        I18n.t('js.global_confirmation_modal.default.cancel')
      }}</SfButtonDs>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfLog } from '@app/adapters/logger'
import { SfCheckbox, SfButtonDs } from '@silverfin/ui-components'
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'ReportTemplateRemovalModal',
  components: {
    SfModal,
    SfCheckbox,
    SfButtonDs,
  },

  data() {
    return {
      templateName: '',
      reportRemoval: false,
      targetUrl: '',
      modalTitle: '',
      eligible: true,

      modalOpen: false,
    }
  },

  methods: {
    openModal(context) {
      this.targetUrl = context.url
      const templateName = '<strong>' + context.templateName + '</strong>'
      this.reportRemoval = false

      this.modalTitle = I18n.t(
        'js.global_confirmation_modal.combined.warning_html',
        { name: templateName }
      )
      this.eligible = context.eligible

      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    async apply() {
      this.modalOpen = false

      const url = new URL(this.targetUrl)
      const urlParams = new URLSearchParams(url.search)

      urlParams.set('remove_company_reports', this.reportRemoval)
      url.search = urlParams.toString()

      try {
        const response = await SFetch.raw(url.toString(), { method: 'DELETE' })
        window.Turbolinks.visit(response.headers.get('Location'))
      } catch (error) {
        SfLog.warn('Failed to remove report template', {
          extra: {
            error,
          },
        })
      }
    },
  },
}
</script>
